(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tracepen-activate"]) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-tracepen-activation]');
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    const currentReturnPath = `${window.location.pathname}${window.location.search}`;
    if (root.dataset.authenticated !== 'true') {
      const loginUrl = `/customer_authentication/login?return_to=${encodeURIComponent(currentReturnPath)}`;
      window.location.replace(loginUrl);
      return;
    }

    const content = root.querySelector('[data-activation-content]');
    if (!content) return;

    const copy = {
      missing: content.dataset.copyMissing || 'Missing device activation details.',
      pairing: content.dataset.copyPairing || 'Pairing…',
      paired: content.dataset.copyPaired || 'TracePen paired.',
      failed: content.dataset.copyFailed || 'Unable to pair this TracePen.',
      network: content.dataset.copyNetwork || 'Unable to reach the pairing service.'
    };

    const params = new URLSearchParams(window.location.search);
    const device = (params.get('d') || '').trim();
    const code = (params.get('c') || '').trim();
    const deviceNode = root.querySelector('[data-device-id]');
    const codeNode = root.querySelector('[data-pair-code]');
    const button = root.querySelector('[data-pair-button]');
    const status = root.querySelector('[data-pair-status]');
    const result = root.querySelector('[data-pair-result]');

    if (deviceNode) deviceNode.textContent = device || '—';
    if (codeNode) codeNode.textContent = code || '—';

    const setStatus = (message, state = '') => {
      if (!status) return;
      status.textContent = message;
      status.dataset.state = state;
    };

    if (!device || !code || device.length > 128 || code.length > 128) {
      setStatus(copy.missing, 'error');
      if (button) button.disabled = true;
      return;
    }

    if (button) button.disabled = false;

    button?.addEventListener('click', async () => {
      button.disabled = true;
      setStatus(copy.pairing);

      try {
        const response = await fetch('/apps/tracepen/pair', {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ device, code })
        });

        if (response.status === 401) {
          window.location.replace(`/customer_authentication/login?return_to=${encodeURIComponent(currentReturnPath)}`);
          return;
        }

        let payload = {};
        try {
          payload = await response.json();
        } catch (_) {
          payload = {};
        }

        if (!response.ok) {
          setStatus(payload.message || copy.failed, 'error');
          return;
        }

        setStatus(payload.message || copy.paired, 'success');
        if (result) {
          result.hidden = false;
          const plan = result.querySelector('[data-result-plan]');
          const subscriptionStatus = result.querySelector('[data-result-status]');
          const expires = result.querySelector('[data-result-expires]');
          if (plan) plan.textContent = payload.plan || '—';
          if (subscriptionStatus) subscriptionStatus.textContent = payload.status || '—';
          if (expires) expires.textContent = payload.expiresAt || '—';
        }
      } catch (_) {
        setStatus(copy.network, 'error');
      } finally {
        button.disabled = false;
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tracepen-devices"]) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-tracepen-devices]');
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    const currentReturnPath = `${window.location.pathname}${window.location.search}`;
    if (root.dataset.authenticated !== 'true') {
      window.location.replace(`/customer_authentication/login?return_to=${encodeURIComponent(currentReturnPath)}`);
      return;
    }

    const content = root.querySelector('[data-devices-content]');
    if (!content) return;

    const copy = {
      loading: content.dataset.copyLoading || 'Loading…',
      error: content.dataset.copyError || 'Unable to load your TracePen account.',
      noDevices: content.dataset.copyNoDevices || 'No TracePens paired yet.',
      noFiles: content.dataset.copyNoFiles || 'No DXF files imported yet.',
      unpair: content.dataset.copyUnpair || 'Unpair',
      unpairing: content.dataset.copyUnpairing || 'Unpairing…',
      active: content.dataset.copyActive || 'Active',
      inactive: content.dataset.copyInactive || 'Inactive',
      projectFallback: content.dataset.copyProjectFallback || 'Unsorted'
    };

    const message = root.querySelector('[data-dashboard-message]');
    const deviceList = root.querySelector('[data-device-list]');
    const fileList = root.querySelector('[data-file-list]');
    const plan = root.querySelector('[data-subscription-plan]');
    const status = root.querySelector('[data-subscription-status]');
    const expires = root.querySelector('[data-subscription-expires]');
    const pill = root.querySelector('[data-subscription-pill]');

    const text = (value, fallback = '—') => {
      if (value === null || value === undefined || value === '') return fallback;
      return String(value);
    };

    const el = (tag, attrs = {}, value = '') => {
      const node = document.createElement(tag);
      Object.entries(attrs).forEach(([key, attrValue]) => {
        if (key === 'class') node.className = attrValue;
        else node.setAttribute(key, attrValue);
      });
      if (value) node.textContent = value;
      return node;
    };

    const renderDevices = (devices = []) => {
      if (!deviceList) return;
      deviceList.replaceChildren();
      if (!devices.length) {
        deviceList.append(el('p', { 'data-device-meta': '' }, copy.noDevices));
        return;
      }

      devices.forEach((device) => {
        const row = el('div', { 'data-device-row': '' });
        const info = el('div');
        info.append(
          el('div', { 'data-device-name': '' }, text(device.name || device.deviceId, 'TracePen')),
          el('div', { 'data-device-meta': '' }, `${text(device.deviceId)} · ${device.active ? copy.active : copy.inactive}`)
        );
        const button = el('button', { type: 'button', 'data-unpair': text(device.deviceId, '') }, copy.unpair);
        row.append(info, button);
        deviceList.append(row);
      });
    };

    const renderFiles = (files = []) => {
      if (!fileList) return;
      fileList.replaceChildren();
      if (!files.length) {
        fileList.append(el('p', { 'data-file-meta': '' }, copy.noFiles));
        return;
      }

      const groups = new Map();
      files.forEach((file) => {
        const project = text(file.project, copy.projectFallback);
        if (!groups.has(project)) groups.set(project, []);
        groups.get(project).push(file);
      });

      groups.forEach((projectFiles, project) => {
        const group = el('section', { 'data-project-group': '' });
        group.append(el('h3', { 'data-project-title': '' }, project));
        projectFiles.forEach((file) => {
          const row = el('div', { 'data-file-row': '' });
          const info = el('div');
          info.append(
            el('div', { 'data-file-name': '' }, text(file.filename)),
            el('div', { 'data-file-meta': '' }, text(file.path || file.uploadedAt))
          );
          row.append(info);
          group.append(row);
        });
        fileList.append(group);
      });
    };

    const renderSubscription = (subscription = {}) => {
      const isActive = subscription.active === true;
      if (pill) {
        pill.dataset.active = isActive ? 'true' : 'false';
        pill.textContent = isActive ? copy.active : copy.inactive;
      }
      if (plan) plan.textContent = text(subscription.plan);
      if (status) status.textContent = text(subscription.status);
      if (expires) expires.textContent = text(subscription.expiresAt);
    };

    const load = async () => {
      if (message) message.textContent = copy.loading;
      try {
        const response = await fetch('/apps/tracepen/dashboard', {
          credentials: 'same-origin',
          headers: { 'Accept': 'application/json' }
        });

        if (response.status === 401) {
          window.location.replace(`/customer_authentication/login?return_to=${encodeURIComponent(currentReturnPath)}`);
          return;
        }

        const payload = await response.json();
        if (!response.ok) throw new Error(payload.message || copy.error);

        renderSubscription(payload.subscription || {});
        renderDevices(Array.isArray(payload.devices) ? payload.devices : []);
        renderFiles(Array.isArray(payload.files) ? payload.files : []);
        if (message) message.textContent = '';
      } catch (error) {
        if (message) message.textContent = error?.message || copy.error;
      }
    };

    root.addEventListener('click', async (event) => {
      const button = event.target.closest('[data-unpair]');
      if (!button) return;
      const device = button.getAttribute('data-unpair');
      if (!device) return;

      button.disabled = true;
      const previous = button.textContent;
      button.textContent = copy.unpairing;
      try {
        const response = await fetch('/apps/tracepen/unpair', {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ device })
        });
        if (!response.ok) {
          let payload = {};
          try { payload = await response.json(); } catch (_) { payload = {}; }
          throw new Error(payload.message || copy.error);
        }
        await load();
      } catch (error) {
        if (message) message.textContent = error?.message || copy.error;
      } finally {
        button.disabled = false;
        button.textContent = previous;
      }
    });

    load();
  })();

  } catch(e) { console.error(e); }
})();
})();
